import { render } from "./FilterSidebarInServiceItems.vue?vue&type=template&id=7312fdce&scoped=true"
import script from "./FilterSidebarInServiceItems.vue?vue&type=script&lang=js"
export * from "./FilterSidebarInServiceItems.vue?vue&type=script&lang=js"

import "./FilterSidebarInServiceItems.vue?vue&type=style&index=0&id=7312fdce&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7312fdce"]])

export default __exports__